import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-self-assessment-routing-component',
  templateUrl: './self-assessment-routing-component.component.html',
  styleUrls: ['./self-assessment-routing-component.component.scss']
})
export class SelfAssessmentRoutingComponentComponent implements OnInit {
  constructor(private route: ActivatedRoute) { }

  ngOnInit(): void {
    
    this.route.params.subscribe(params => {
      const param1 = params['param1'];
      const param2 = params['param2'];
      // Do whatever you need with the parameters
    });
  }
}
